<div class="d-flex flex-column justify-content-center align-items-center modal-product" style="padding:30px 10px;">
    <div class="dialog-title">
        <h4>Dane Rekbota</h4>
        <button mat-icon-button aria-label="close dialog" mat-dialog-close tabindex="-1"
            style="position:absolute; top:0; right:0;">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content class="w-100 d-flex flex-column align-items-center">

        <table>
            <tr>
                <td class="p-1"><p>Numer seryjny:</p></td>
                <td class="p-1"><p>{{ rekbotsService.selectedMapRekbot?.rekbot }}</p></td>
            </tr>
            <tr>
                <td class="p-1"><p>Adres:</p></td>
                <td class="p-1"><p> {{  rekbotsService.selectedMapRekbot?.post_code }} {{  rekbotsService.selectedMapRekbot?.city }}</p>
                    <p> {{  rekbotsService.selectedMapRekbot?.street }}</p></td>
            </tr>
            <tr>
                <td class="p-1"><p>Organizacja:</p></td>
                <td class="p-1"><p> {{  rekbotsService.selectedMapRekbot?.organization }}</p>
                    </td>
            </tr>
            <tr>
                <td class="p-1"><p>Kontakt:</p></td>
                <td class="p-1">
                    <p>Osoba: {{  rekbotsService.selectedMapRekbot?.contact_person }}</p>
                    <p>Firma: {{  rekbotsService.selectedMapRekbot?.contact_company }}</p>
                    <p>Tel: {{  rekbotsService.selectedMapRekbot?.contact_phone }}</p>
                    <p>Email: {{  rekbotsService.selectedMapRekbot?.contact_email }}</p>
                </td>
            </tr>

        </table>

        

        <mat-dialog-actions class="d-flex flex-row justify-content-between w-100 p-2">
            <button  mat-flat-button color="warn" mat-dialog-close class="w-b w-40">Zamknij</button>
        </mat-dialog-actions>
    </mat-dialog-content>
</div>